import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var MultipleArrowsIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 257 110" }),
    React.createElement("path", { d: "M52.9717 110H31L86.0283 55L31 0H52.9717L108 55L52.9717 110Z", fill: "#DFDFDF" }),
    React.createElement("path", { d: "M21.9717 110H0L55.0283 55L0 0H21.9717L77 55L21.9717 110Z", fill: "#DFDFDF" }),
    React.createElement("path", { d: "M82.9717 110H61L116.028 55L61 0H82.9717L138 55L82.9717 110Z", fill: "#DFDFDF" }),
    React.createElement("path", { d: "M112.972 110H91L146.028 55L91 0H112.972L168 55L112.972 110Z", fill: "#DFDFDF" }),
    React.createElement("path", { d: "M141.972 110H120L175.028 55L120 0H141.972L197 55L141.972 110Z", fill: "#DFDFDF" }),
    React.createElement("path", { d: "M170.972 110H149L204.028 55L149 0H170.972L226 55L170.972 110Z", fill: "#DFDFDF" }),
    React.createElement("path", { d: "M201.972 110H180L235.028 55L180 0H201.972L257 55L201.972 110Z", fill: "#DFDFDF" }))); };

export default MultipleArrowsIcon;
